import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../views/pc/store/index'
// 公共组件 侧边栏 顶部 底部
import pc_main from '@/views/pc/components/HelloWorld'
import wechat_main from '@/views/wechat/components/main'
//pc 登录页
import login from '@/views/pc/login.vue'
import NotFound from '@/views/pc/publicComponents/notFound.vue'

import globalPath from '@/assets/script/globalPath'
import common from '@/assets/script/common.js'

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/',
            name: 'pc_main',
            component: pc_main,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "/",
                    redirect: '/home'
                }]
        },
        {
            path: '/wechat',
            name: 'wechat_main',
            component: wechat_main,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "/wechat",
                    redirect: '/wechat/login'
                },
                {
                    path: '/wechat/login',
                    name: 'login',
                    component: () => import ('@/views/wechat/page/login.vue')
                },
                {
                    path: '/wechat/purchase',
                    name: 'purchase',
                    component: () => import ('@/views/wechat/page/purchase.vue')
                },
                {
                    path: '/wechat/package',
                    name: 'package',
                    component: () => import ('@/views/wechat/page/package.vue')
                },
                {
                    path: '/wechat/Rechargerecord',
                    name: 'Rechargerecord',
                    component: () => import ('@/views/wechat/page/Rechargerecord.vue')
                },
                {
                    path: '/wechat/packageRecharge',
                    name: 'packageRecharge',
                    component: () => import ('@/views/wechat/page/packageRecharge.vue')
                },
                {
                    path: '/wechat/comproblem',
                    name: 'comproblem',
                    component: () => import ('@/views/wechat/page/comproblem.vue')
                },
                {
                    path: '/wechat/home',
                    name: 'home',
                    component: () => import ('@/views/wechat/page/home.vue')
                },
                {
                    path: '/wechat/activationCard',
                    name: 'activationCard',
                    component: () => import ('@/views/wechat/page/activationCard.vue')
                },
                {
                    path: '/wechat/Recharge',
                    name: 'Recharge',
                    component: () => import ('@/views/wechat/page/Recharge.vue')
                }
            ]
        }
    ]
});
let router_lise = [];
// 未登录路由拦截
router.beforeEach((to, from, next) => {
    let isLogin = common.getCookie('tibiot-personal-card'); // 获取token
    //路由设置
    if(to.path.includes('/wechat')) {
        //卡片激活后跳转首页后，不可以后退
        if(from.path == '/wechat/login' && to.path  == '/wechat/Recharge') { //禁止激活后后退到激活页
            next({path:'/wechat/login'})
        }else if(from.path == '/wechat/home' && to.path  == '/wechat/Recharge'){ //禁止激活后后退到激活页
            next({path:'/wechat/login'})
        }else{
            next()
        }
    }else {
        if (isLogin) {
            getMbx(to); //获取面包屑
            getMenuId(to.meta.index) //获取当前页面的按钮权限
            if (router_lise == 0) { //路由开始
                getRouters(to, next);
            } else {
                next()
            }
        }else {
            if (to.path == '/login') {
                next()
            }else {
                next({path: "/login"})
            }
        }
    }
});
// 当在渲染一个路由的过程中，需要尝试解析一个异步组件时发生错误
router.onError((error) => {
    console.log('error:'+error.message);    
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) { 
        alert('检测到数据更新，页面重新载入!');
        if(!window.location.href.includes('/wechat')){
            window.location.reload();
        }else{
            //重新定向到新页面，同时刷新打开的这个页面
            if(common.getCookie('url')){
                window.location.href = common.getCookie('url')+"/wechat/login";
            }else{
                let aa =  window.location.href;
                let bb = aa.indexOf('/wechat');
                let cc = aa.substring(0,bb);
                window.location.href = cc + "/wechat/login";
            }
        }
    }
});

//获取页面按钮
function getMenuId(index){
    if(index){
        axios({
            method: 'post',
            url: globalPath.globalPath.api + 'admin/role/getSysRoleMenu',
            data: {menuId:index},
        })
        .then(function (res) {
            if (res.data.code == 200) {
                store.commit('setButtons', res.data.data);//存储页面的按钮
            }
        })
    }
}
//设置面包屑
function getMbx(to){
    if (getCrumbs(to).flog) {
        let cc = store.state.jumpMenu;
        if (store.state.jumpMenu.index == 2){
            getCrumbs(to).bb[2] = cc;
        } else {
            getCrumbs(to).bb[1] = cc;
        } 
        store.commit('setCrumbsArr', getCrumbs(to).bb);
    } else {
        store.commit('setCrumbsArr', getCrumbs(to).mianbaoxian);
    }
}
//获取面包屑
function getCrumbs(to){
    let bb = store.state.crumbsArr; //储存面包屑
    let arrmenu = store.state.menu;
    let mianbaoxian = [];
    let flog = true;
    for (let i = 0; i < arrmenu.length; i++) {
        if (arrmenu[i].menuUrl == to.path) {
            mianbaoxian[0] = {
                name: arrmenu[i].menuName,
                url: arrmenu[i].menuUrl
            };
            mianbaoxian.length = 1;
            flog = false;
            break;
        } else {
            if (arrmenu[i].children) {
                for (let j = 0; j < arrmenu[i].children.length; j++) {
                    if (arrmenu[i].children[j].menuUrl == to.path) {
                        mianbaoxian[0] = {
                            name: arrmenu[i].menuName,
                            url: arrmenu[i].children[j].menuUrl
                        };
                        mianbaoxian[1] = {
                            name: arrmenu[i].children[j].menuName,
                            url: arrmenu[i].children[j].menuUrl
                        };
                        mianbaoxian.length = 2;
                        flog = false;
                        break;
                    }
                }
            }
        }
    }
    return {bb,mianbaoxian,flog}
}

//获取路由
function getRouters(to, next) {
    axios({
        method: 'post',
        url: globalPath.globalPath.api + 'home/getSysMenuRoute',
    })
    .then(function (res) {
        if (res.data.code == 200) {
            router_lise = addDynamicRoutes(res.data.data);
            router.options.routes[1].children = router_lise;
            router.options.routes[3] = {path: '/404', name: '404', component: NotFound};
            router.options.routes[4] = {path: '*', redirect: '/404'};
            router.addRoutes(router.options.routes);
        }
        next({...to})
    })
}
function addDynamicRoutes(menuList = [], routes = []) {
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].menuUrl) {
            let url = menuList[i].menuUrl;
            let route = {
                path: url,
                name: url.substr(1),
                component: () => import(`@/views/pc/page${url}`),
                meta: {
                    index: menuList[i].id,
                }
            };
            routes.push(route);
        }
    }
    return routes
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js